import Vue from 'vue'
import Router from 'vue-router'
/**
 * 重写路由的push方法
 */
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}
// 模板
const Index = () => import('@/page/index')
const Andon = () => import('@/page/andon')
const EquipmentData = () => import('@/page/equipment-data')
const Data = () => import('@/page/data')
const GembaWalk = () => import('@/page/gemba-walk')
Vue.use(Router)

const router = new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      name: '',
      meta: {
        title: '',
      },
      component: Index,
      redirect: '/andon',
      children: [
        {
          path: '/andon',
          name: 'andon',
          meta: {
            title: 'TE ENERGY设备Andon看板',
          },
          component: Andon,

        },
        {
          path: '/equipment-data',
          name: 'equipment-data',
          meta: {
            title: 'TE ENERGY设备数据看板',
          },
          component: EquipmentData,

        },
        {
          path: '/data',
          name: 'data',
          meta: {
            title: 'TE ENERGY模具数据看板',
          },
          component: Data,
        },
        {
          path: '/gemba-walk',
          name: 'data',
          meta: {
            title: 'TE Gemba Walk看板',
          },
          component: GembaWalk,
        },
        
      ]
    },
  ]
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js